<template>
  <div class="form-group" :class="{'disabled': parseBoolean(disabled)}">
    <label v-if="label" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <textarea :id="id" ref="input" type="text"
              :value="value"
              :placeholder="placeholder"
              :maxlength="maxlength"
              :rows="rows"
              :style="textareaStyle"
              class="form-control"
              :class="{'is-invalid': invalid}"
              :disabled="parseBoolean(disabled)"
              @input="updateValue($event.target.value);"/>
    <local-errors :value="errors"/>
    <div v-if="help" class="form-text"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "input-textarea",
  computed: {
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  props: ["id", "value", "errors", "label", "placeholder", "language", "required", "rows", "maxlength", "disabled", "textareaStyle"],
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    }
  }
}
</script>
